/**
 * I am a flag stored in localStorage
 */
export class Flag {
	constructor(key) {
		this.key = key
	}

	isSet() {
		const value = localStorage.getItem(this.key)
		return !!value
	}

	set() {
		localStorage.setItem(this.key, true)
	}
}